<template>
    <div class="movie_index_wrap">
        <div class="topMenu fr ac jsb">
            <div @click="goCityList" class="location fr ac">
                <img src="../../../static/imgs/movie/down.png" alt />
                <span>{{ selectedCity }}</span>
            </div>
            <ul class="menu fr ac">
                <li @click="switchMenu('hot')" :class="menuType == 'hot' ? 'active' : 'fade'">
                    热映
                </li>
                <li @click="switchMenu('future')" :class="menuType == 'future' ? 'active' : 'fade'">
                    待映
                </li>
            </ul>
            <!-- <img class="scanIco" src="../../../static/imgs/movie/scan.png" alt=""> -->
            <img @click="goMe" class="meIco" src="../../../static/imgs/movie/me.png" alt />
        </div>

        <div class="bannerWrap">
            <mt-swipe v-if="bannerList.length" class="banner" :auto="5000">
                <mt-swipe-item v-for="(item, index) in bannerList" :key="index">
                    <img @click="viewBanner(item)" :src="imgBaseUrl + item.img" alt />
                </mt-swipe-item>
            </mt-swipe>
        </div>

        <!-- <div class="section fc ac">
            <div class="section_title fr ac jsb">
                <h4>热映影片</h4>
                <div class="fr ac">
                    <span>全部</span>
                    <img src="../../../static/imgs/movie/enter.png" alt="" />
                </div>
            </div>
            <div class="list_wrap fr ac">
                <div class="list_content fr ac">
                    <div
                        class="list_item fc"
                        v-for="(item, index) in hotMovieList"
                        :key="index"
                    >
                        <img :src="item.logo + '_180x180'" alt="" />
                        <h5 class="ellipsis">{{ item.name }}</h5>
                        <span class="ellipsis">{{
                            item.actors ? item.actors : item.director
                        }}</span>
                        <button>购票</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="section fc ac">
            <div class="section_title fr ac jsb">
                <h4>待映新片</h4>
                <div class="fr ac">
                    <span>全部</span>
                    <img src="../../../static/imgs/movie/enter.png" alt="" />
                </div>
            </div>
            <div class="list_wrap fr ac">
                <div class="list_content fr ac">
                    <div
                        class="list_item fc"
                        v-for="(item, index) in futureMovieList"
                        :key="index"
                    >
                        <img :src="item.logo + '_180x180'" alt="" />
                        <h5 class="ellipsis">{{ item.name }}</h5>
                        <span class="ellipsis">{{
                            item.actors ? item.actors : item.director
                        }}</span>
                        <button v-show="item.buytype == 'prebuy'">预售</button>
                    </div>
                </div>
            </div>
        </div> -->

        <div class="quickMenu fr ac jsb">
            <div @click="goOrderList" class="menuItem fc ac">
                <img src="../../../static/imgs/movie/code.png" alt />
                <span>取票码</span>
            </div>
            <div @click="viewOrders('pending')" class="menuItem fc ac">
                <img src="../../../static/imgs/movie/pendingOrder.png" alt />
                <span>待付款单</span>
            </div>
            <div @click="viewCoupons" class="menuItem fc ac">
                <img src="../../../static/imgs/movie/coupon.png" alt />
                <span>我的卡券</span>
            </div>
            <div @click="contact" class="menuItem fc ac">
                <img src="../../../static/imgs/movie/service.png" alt />
                <span>客服服务</span>
            </div>
        </div>
        <div class="movieList fc" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="0">
            <div @click="goMovieDetial(item.id)" v-for="(item, index) in movieList" :key="index" class="movieItem fr">
                <img class="movieImg" :src="item.logo + '_180x180'" alt />
                <div class="movieInfo fr ac">
                    <div class="basicInfo fc jsb">
                        <h3 class="movieTitle">{{ item.name }}</h3>
                        <p>
                            <span v-show="item.showmark" class="mark">{{
                                item.showmark
                            }}</span>
                        </p>
                        <p class="ellipsis" v-show="item.director">
                            导演：{{ item.director }}
                        </p>
                        <p class="ellipsis" v-show="item.actors">
                            主演：{{ item.actors }}
                        </p>
                    </div>
                    <button @click.stop="buyTicket(item.id)" v-show="item.buytype == 'buy'" class="buyBtn">
                        购票
                    </button>
                    <button @click.stop="buyTicket(item.id)" v-show="item.buytype == 'prebuy'" class="preBtn">
                        预售
                    </button>
                </div>
            </div>
        </div>
        <div class="target-wrap">
            <div v-if="target" class="target_btn" @click="targetPage">
                <img src="../../../static/imgs/movie/back2.png"/>
            </div>
        </div>
        <tab-bar></tab-bar>
    </div>
</template>

<script>
import navBar from "../../components/common/navBar.vue";
import tabBar from "../../components/common/tabBar.vue";
import { Indicator, MessageBox, Toast, Swipe, SwipeItem } from "mint-ui";
export default {
    data() {
        return {
            menuType: "hot",
            movieList: [],
            imgBaseUrl: this.$global.imgBaseUrl,
            bannerList: [],
            futurePage: 0,
            cityList: [],
            hotMovieList: [],
            futureMovieList: [],
            domainType: this.$global.domainType,
            selectedCity: this.getLocal("selectedCity")
                ? this.getLocal("selectedCity")
                : this.getLocal("currentCity")
                    ? this.getLocal("currentCity")
                    : "上海",
            citycode: this.getLocal("selectedCityCode")
                ? this.getLocal("selectedCityCode")
                : this.getLocal("currentCityCode")
                    ? this.getLocal("currentCityCode")
                    : "310100",
            openid: this.getLocal("openid") ? this.getLocal("openid") : "", //微信openid
            code: sessionStorage.getItem("code")
                ? sessionStorage.getItem("code")
                : "", //获取微信openid需要的code
        };
    },
    computed: {
        target() {
            let target = this.$cookies.get('target');
            return target ? target : false;
        }
    },
    created() {
        var t = new Date(),
            r =
                (t.getFullYear(),
                    t.getMonth(),
                    t.getDate(),
                    "6B694D84-67DE-4346-B3C8-340CDF06DE41");
        console.log(
            "test: ",
            (1, 3, 4, "6B694D84-67DE-4346-B3C8-340CDF06DE41"),
            this.$md5("6B694D84-67DE-4346-B3C8-340CDF06DE41")
        );
        this.getCityList();
        this.getTitleInfo();
        this.getBannerList();
        if (this.code && !this.openid) {
            this.getOpenId();
        }
    },
    activated() {
        this.selectedCity = this.getLocal("selectedCity")
            ? this.getLocal("selectedCity")
            : this.getLocal("currentCity")
                ? this.getLocal("currentCity")
                : "上海";
        this.citycode = this.getLocal("selectedCityCode")
            ? this.getLocal("selectedCityCode")
            : this.getLocal("currentCityCode")
                ? this.getLocal("currentCityCode")
                : "310100";
    },
    components: {
        navBar,
        tabBar,
    },
    methods: {
        //获取城市列表
        getCityList() {
            this.removeLocal("selectedCity");
            this.removeLocal("selectedCityCode");
            this.removeLocal("currentCity");
            this.removeLocal("currentCityCode");
            this.removeLocal("countycode");
            this.removeLocal("selectedCounty");
            this.removeLocal("locationInfo");
            this.$post({
                method: "movie.city.list",
            }).then((res) => {
                if (res.success) {
                    this.citylist = res.data.citylist;
                    if (!this.getLocal("currentCity")) {
                        console.log(this.getLocal("currentCity"));
                        try {
                            this.getLocation();
                        } catch (error) {
                            Indicator.close();
                            Toast({
                                message: error,
                                position: "middle",
                                duration: 2000,
                                className: "toastBox",
                            });
                        }
                    }
                }
            });
        },
        // 定位
        getLocation() {
            Indicator.open("定位中...");
            let _this = this;
            AMap.plugin("AMap.Geolocation", function () {
                var geolocation = new AMap.Geolocation({
                    // 是否使用高精度定位，默认：true
                    enableHighAccuracy: true,
                    // 设置定位超时时间，默认：无穷大
                    timeout: 5000,
                });
                geolocation.getCurrentPosition();
                AMap.event.addListener(geolocation, "complete", onComplete);
                AMap.event.addListener(geolocation, "error", onError);
                // data是具体的定位信息
                function onComplete(data) {
                    Indicator.close();
                    console.log("具体的定位信息", data);
                    _this.setLocal("locationInfo", data.position);
                    _this.matchCityCode(data.formattedAddress);
                }
                function onError(data) {
                    // 失败 启用 ip定位
                    Indicator.close();
                    AMap.plugin("AMap.CitySearch", function () {
                        var citySearch = new AMap.CitySearch();
                        citySearch.getLocalCity(function (status, result) {
                            if (status === "complete" && result.info === "OK") {
                                // 查询成功，result即为当前所在城市信息
                                console.log("通过ip获取当前城市：", result);
                                _this.matchCityCode(result.city);
                            }
                        });
                    });
                }
            });
        },
        matchCityCode(txt) {
            console.log(txt);
            for (let i of this.citylist) {
                if (txt.indexOf(i.name) >= 0) {
                    console.log(i.name, i.citycode);
                    this.selectedCity = i.name;
                    this.citycode = i.citycode;
                    this.setLocal("currentCity", i.name);
                    this.setLocal("currentCityCode", i.citycode);
                    break;
                }
            }
            if (!this.getLocal("currentCity")) {
                MessageBox.confirm("定位失败，是否手动选择城市?")
                    .then((action) => {
                        if (action == "confirm") {
                            this.$router.push("/cityList");
                        }
                    })
                    .catch((err) => { });
            } else {
                this.getMovieList();
                // this.getHotMovieList();
                // this.getFutureMovieList();
            }
        },
        // 城市列表
        goCityList() {
            this.$router.push("/cityList");
        },
        targetPage() {
            let targetPage = this.$cookies.get('target');
            if (targetPage) {
                if (targetPage.indexOf('http') < 0) {
                    targetPage = 'http://' + targetPage;    
                }
                window.location.href = targetPage;
            }
        },
        // 切换菜单
        switchMenu(type) {
            this.movieList = [];
            this.futurePage = 0;
            this.menuType = type;
            this.getMovieList();
        },
        // 获取电影列表
        getMovieList() {
            if (this.menuType == "hot") {
                this.$post({
                    citycode: this.citycode,
                    method: "movie.hot.list",
                    appkey: "dumovie_wxmicro",
                }).then((res) => {
                    this.movieList = res.data.movielist;
                });
            } else {
                this.$post({
                    page_no: this.futurePage,
                    citycode: this.citycode,
                    method: "movie.future.list",
                    appkey: "dumovie_wxmicro",
                }).then((res) => {
                    this.movieList = this.movieList.concat(res.data.movielist);
                });
            }
        },
        getHotMovieList() {
            this.$post({
                citycode: this.citycode,
                method: "movie.hot.list",
                appkey: "dumovie_wxmicro",
            }).then((res) => {
                this.hotMovieList = res.data.movielist;
            });
        },
        getFutureMovieList() {
            this.$post({
                page_no: this.futurePage,
                citycode: this.citycode,
                method: "movie.future.list",
                appkey: "dumovie_wxmicro",
            }).then((res) => {
                this.futureMovieList = this.futureMovieList.concat(res.data.movielist);
            });
        },
        // 加载更多
        loadMore() {
            if (this.$route.path == "/" && this.getLocal("currentCity")) {
                this.futurePage++;
                // this.getMovieList();
                this.getHotMovieList();
                this.getFutureMovieList();
            }
        },
        // 电影详情
        goMovieDetial(id) {
            // 微信环境需要openid
            let ua = navigator.userAgent.toLowerCase();
            let isWeixin = ua.indexOf("micromessenger") != -1 ? true : false;
            if (isWeixin && !this.openid) {
                let domain =
                    window.location.protocol + "//" + window.location.host; // 域名
                const url = encodeURI(
                    domain + "/duwap/static/getCode/getCode.html?usertype=movie"
                );
                window.location.href = url;
                return;
            }
            this.$router.push({
                path: "/movieDetail",
                query: { movieid: id, citycode: this.citycode },
            });
        },
        buyTicket(id) {
            // 微信环境需要openid
            let ua = navigator.userAgent.toLowerCase();
            let isWeixin = ua.indexOf("micromessenger") != -1 ? true : false;
            if (isWeixin && !this.openid) {
                let domain =
                    window.location.protocol + "//" + window.location.host; // 域名
                const url = encodeURI(
                    domain + "/duwap/static/getCode/getCode.html?usertype=movie"
                );
                window.location.href = url;
                return;
            }
            this.$router.push({
                path: "/cinemaList",
                query: { movieid: id, citycode: this.citycode },
            });
        },
        // 获取微信openid
        getOpenId() {
            this.$post({
                method: "weixin.get.openid",
                code: this.code,
            }).then((res) => {
                if (res.success) {
                    this.openid = res.data;
                    this.setLocal("openid", res.data);
                }
            });
        },
        goSearch() {
            this.$router.push({
                path: "/searchCinema",
                query: { citycode: this.citycode },
            });
        },
        goMe() {
            this.$router.push("/meIndex");
        },
        viewOrders(status) {
            this.$router.push({
                path: "orderList",
                query: { orderStatus: status },
            });
        },
        goOrderList() {
            let auth_code = this.getLocal("auth_code")
                ? this.getLocal("auth_code")
                : "";
            if (auth_code) {
                window.location.href =
                    "https://wx." +
                    this.domainType +
                    "/app/order/movie/list?auth_code=" +
                    auth_code +
                    "&app_source=h5";
            } else {
                Toast({
                    message: "请先登录！",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox",
                });
                this.$router.push("/logup");
            }
        },
        viewCoupons() {
            this.$router.push("/couponList");
        },
        getTitleInfo() {
            this.$post({
                method: "merchant.info",
            }).then((res) => {
                if (res.success) {
                    // document.title = res.data.name;
                    // this.setLocal("pageTitle", res.data.name);
                }
            });
        },
        contact() {
            let serviceNo = this.getLocal("serviceNo")
            window.location.href = "tel://" + serviceNo;
        },
        viewBanner(item) {
            switch (item.relate) {
                case "movie":
                    this.$router.push({
                        path: "/movieDetail",
                        query: {
                            movieid: item.relateid,
                            citycode: this.citycode,
                        },
                    });
                    break;
                default:
                    break;
            }
        },
        getBannerList() {
            this.$post({
                method: "ad.list",
                type: "wap",
                device: "wxmicro",
                citycode: this.citycode,
            }).then((res) => {
                if (res.success) {
                    this.bannerList = res.data.slide;
                }
            });
        },
    },
};
</script>
<style lang="scss">
@import "../../../static/css/base";
p {
    max-height: 100%;
}
.movie_index_wrap {
    .topMenu {
        width: 100%;
        height: 100px;
        background-color: #fff;
        padding: 0 20px;
        box-sizing: border-box;
        border-bottom: 1px solid #c8c7cc; /* no */
        position: fixed;
        top: 0;
        z-index: 10;
        .location {
            width: 170px;
            span {
                font-size: 32px;
                color: $themeColor;
            }
            img {
                width: 24px;
                height: 20px;
                margin-right: 10px;
            }
        }
        .menu {
            width: 240px;
            height: 60px;
            li {
                width: 120px;
                height: 60px;
                line-height: 60px;
                text-align: center;
                font-size: 28px;
            }
            li:first-of-type {
                border-radius: 10px 0 0 10px;
            }
            li:last-of-type {
                border-radius: 0 10px 10px 0;
            }
            .active {
                background: $themeColor;
                color: #fff;
                border: 1px solid $themeColor;
            }
            .fade {
                background: #fff;
                color: $themeColor;
                border: 1px solid $themeColor;
            }
        }
        .meIco {
            width: 36px;
            height: 42px;
            margin: 0 10px 0 124px;
        }
        .scanIco {
            width: 40px;
            height: 40px;
            margin-left: 130px;
        }
    }
    .section {
        width: 100%;
        margin-bottom: 30px;
        background: #fff;
        .section_title {
            width: 100%;
            padding: 0 30px;
            box-sizing: border-box;
            height: 90px;
            h4 {
                font-size: 32px;
                color: #3f4956;
            }
            div {
                span {
                    font-size: 24px;
                }
                img {
                    width: 15px;
                    height: 26px;
                    margin-left: 20px;
                }
            }
        }
        .list_wrap {
            width: 100%;
            overflow-x: scroll;
            .list_content {
                .list_item {
                    width: 160px;
                    height: 390px;
                    margin-right: 30px;
                    img {
                        width: 160px;
                        height: 240px;
                        border-radius: 8px;
                    }
                    h5 {
                        font-size: 24px;
                        margin-top: 20px;
                    }
                    span {
                        color: #999;
                        font-size: 20px;
                        margin-top: 10px;
                    }
                    button {
                        width: 84px;
                        height: 38px;
                        line-height: 38px;
                        margin-top: 10px;
                        border-radius: 8px;
                        font-size: 22px;
                        color: #fff;
                        background: #ff587b;
                    }
                }
                .list_item:first-of-type {
                    margin-left: 30px;
                }
            }
        }
    }
    .bannerWrap {
        width: 100%;
        height: 320px;
        margin-top: 100px;
        .banner {
            width: 100%;
            height: 320px;
            img {
                width: 100%;
                height: 320px;
            }
        }
    }

    .quickMenu {
        width: 100%;
        padding: 0 70px;
        // padding: 0 120px;
        box-sizing: border-box;
        height: 165px;
        background: #fff;
        border-bottom: 1px solid #e9e9e9;
        // margin-top: 100px;
        .menuItem {
            img {
                width: 70px;
                height: 70px;
                margin-bottom: 12px;
            }
            span {
                font-size: 22px;
            }
        }
    }
    .movieList {
        background-color: #fff;
        padding-bottom: 98px;
        .movieItem {
            width: calc(100% - 24px);
            padding: 24px 24px 24px 0;
            margin-left: 24px;
            box-sizing: border-box;
            border-bottom: 1px solid #c8c7cc; /* no */
            height: 228px;
            .movieImg {
                width: 128px;
                height: 180px;
                margin-right: 20px;
            }
            .movieInfo {
                width: calc(100% - 148px);
                .basicInfo {
                    width: calc(100% - 140px);
                    margin-right: 20px;
                    height: 180px;
                    p {
                        font-size: 22px;
                    }

                    .movieTitle {
                        // max-width: 370px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        font-size: 36px;
                        line-height: 50px;
                    }
                    .mark {
                        font-size: 24px;
                        color: $themeColor;
                        line-height: 36px;
                        padding: 1px 4px;
                        border: 1px solid $themeColor;
                        display: inline-block;
                        border-radius: 8px;
                    }
                }
                .buyBtn {
                    width: 120px;
                    height: 60px;
                    border-radius: 8px;
                    font-size: 28px;
                    background-color: $themeColor;
                    color: #fff;
                    // border: 1px solid $themeColor; /* no */
                }
                .preBtn {
                    width: 120px;
                    height: 60px;
                    border-radius: 8px;
                    font-size: 28px;
                    background-color: #00abff;
                    color: #fff;
                }

                .rating {
                    color: $themeColor;
                    font-size: 28px;
                }
                .actorBox {
                    margin-top: 22px;
                    .actorInfo {
                        width: 420px;
                        height: 116px;
                    }
                    .actorInfo p {
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        font-size: 26px;
                        line-height: 36px;
                        color: #818181;
                    }
                    button {
                        width: 120px;
                        height: 60px;
                        border-radius: 8px;
                        font-size: 28px;
                        background-color: #fff;
                    }
                    .buyBtn {
                        color: $themeColor;
                        border: 1px solid $themeColor; /* no */
                    }
                }
            }
        }
    }
    .mint-msgbox {
        font-size: 28px !important;
        border-radius: 10px;
        .mint-msgbox-header {
            padding-top: 30px;
            .mint-msgbox-title {
                font-size: 30px !important;
            }
        }
        .mint-msgbox-content {
            padding: 30px;
        }
        .mint-msgbox-btns {
            height: 70px;
        }
    }
    .noData {
        width: 100%;
    }
}

.target_btn {
    position: fixed;
    z-index: 29;
    bottom: 150px;
    right: 40px;
    background-color: #fff;
    border-radius: 50%;
    box-shadow: 1px 1px 5px #82848a;
    padding: 15px;
    img {
        width: 60px;
        height: 60px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/movie/movieIndex.vue